import { OperatorTask } from 'modules/common/components/MemberOperator/MemberOperator.interfaces';
import collectiveApi from 'modules/common/collectiveApi';

export default async function getOperatorTask(taskId: string) {
    const { data } = await collectiveApi.get<OperatorTask>(`/v2/members/tasks/${taskId}/`);
    return data;
}
